<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24">
    <path
      d="M12.145 10.8485C14.5884 10.8485 16.5692 8.86773 16.5692 6.42427C16.5692 3.98081 14.5884 2 12.145 2C9.70152 2 7.7207 3.98081 7.7207 6.42427C7.7207 8.86773 9.70152 10.8485 12.145 10.8485Z"
    />
    <path
      d="M22.3319 19.4295C22.3319 19.4295 22.3319 19.345 22.3319 19.3027C22.3319 19.3027 22.3319 19.3027 22.3319 19.2886C22.2192 15.4843 17.7104 12.4268 12.1589 12.4268C6.60744 12.4268 2.1409 15.4561 2 19.2463C2 19.2604 2 19.2886 2 19.3027C2 19.3168 2 19.3309 2 19.3591C2 19.3872 2 19.4154 2 19.4436C2.05636 21.5007 6.6638 22.9097 12.1589 22.9097C17.654 22.9097 22.3319 21.2612 22.3319 19.4436V19.4295Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconUserCircle',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
